import { render } from "./Arena_Chats.vue?vue&type=template&id=674f8153&scoped=true"
import script from "./Arena_Chats.vue?vue&type=script&lang=js"
export * from "./Arena_Chats.vue?vue&type=script&lang=js"

import "./Arena_Chats.vue?vue&type=style&index=0&id=674f8153&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674f8153"]])

export default __exports__